import { createFileRoute } from '@tanstack/react-router';
import { EventForm } from '../../pages/EventForm';
import { requireAdminRoute } from '@/lib/utils/route-auth.utils';

export const Route = createFileRoute('/_authenticated/events/new')({
  beforeLoad: ({ context }) => requireAdminRoute(context),
  component: AddEventPage,
});

function AddEventPage() {
  return <EventForm mode="add" />;
}
